<script>
export default {
  name: 'ShowTransfer',
  data() {
    return {
      commentMaxLength: 255,
      transferId: '',
      transfer: {createdAt: '',dispatchedAt: '', receivedAt: '' },
      transferDetail: [],
      transferRequests: [],
      products: [],
      locations: [],
      managedLocations: [],
      usrs: [],
      comments: [],
      comment: '',
      statusTranslated: '',
      availableInventory: [],
    };
  },
  computed: {
        sidebarData() {
          return this.$store.getters['sidebarData'];
        },
        userData() {
          return this.$store.getters['userData'];
        }
      },
  methods: {
    printPage() {

      let printContents = document.getElementById('printMe').innerHTML;

      let printWindow = window.open('', '_blank');
      printWindow.document.write(`
<html>
    <style>
    .grid-container {
        display: grid;
        grid-template-columns: 1fr 1fr; /* this splits your container into two equal width columns */
        grid-gap: 1em; /* this is optional, it sets some space between your columns */
        width: 800px;
        margin-left: auto;
        margin-right: auto;
    }

    .table-container {
        max-height: 500px;
        width: 808px;
        background: rgba(237, 237, 237, 0.68);
        border-color: #97989AFF;
        border-style: solid;
        border-width: 1px;
        border-radius: 8px;
        margin: 0 auto 20px auto;
    }

    .table-container table {
        width: 800px;
        border-collapse: collapse;
        margin-left: auto;
        margin-right: auto;
        font-family: 'SDE-Font-Regular', sans-serif;
    }

    .table-container table td {
        padding: 1px;
    }

    .table-container table thead th {
        background-color: #97989AFF;
        color: #f9f9f9;
        font-weight: bold;
        font-size: 15px;
        border: 1px solid #97989AFF;
        border-left: none;
    }

    .table-container table tbody td {
        color: #97989AFF;
        border: 1px solid #97989AFF;
        font-size: 15px;
        text-align: left;
    }

    .table-container table tbody th {
        color: #97989AFF;
        border: 1px solid #97989AFF;
        font-size: 15px;
        border-left: none;
    }

    .table-container table tbody tr {
        background-color: #f9fafb;
    }

    .table-container table tbody tr:nth-child(odd) {
        background-color: #ffffff;
    }

    .table-container table tbody tr:hover td {
        color: white;
    }

    .table-container table tbody tr:hover th {
        color: white;
    }

    .table-container thead tr th {
        position: sticky;
        top: -1px;
        box-shadow: 0px 2px 2px #f0f0f0; /* Adds a shadow */
        z-index: 1;
    }
    </style>
    <head>
        <title>Print</title>
    </head>
    <body>
        ${printContents}
    </body>
</html>`
);
      printWindow.document.close();
      printWindow.print();

    },
    async cancel() {
      try {
        let data = {
          comment: this.comment,
          type: "cancel"
        }
        let res = await this.$api.put(`/auth/transfers/${this.transfer.id}`, data, {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        });
        if (res.status.toString() === "200") {
          this.$swal.fire({
            icon: 'success',
            title: 'Se han guardado los cambios',
            text: '',
            customClass: {
              popup: 'mySwal'
            }
          }).then(result => {
            if (result.isConfirmed) {
              this.$router.push({name:'ShowTransfer', params:{id:this.transfer.id}})
            }
          })
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'No se ha podido registrar los cambios',
          customClass: {
            popup: 'mySwal'
          }
        });
      }
    },
    async getTransfer(id) {
      try {
        let res = await this.$api.get(`/auth/transfers/${id}/data`, {
          params: {
            id: id
          }
        })
        if (res.status.toString() === "200") {
          this.transfer = res.data
          if (this.transfer === null) {
            this.transfer = ''
          } else {
            switch (this.transfer.status) {
              case "requested":
                this.statusTranslated = "solicitado";
                break;
              case "cancelled":
                this.statusTranslated = "cancelado";
                break;
              case "req_rejected":
                this.statusTranslated = "solicitud rechazada en origen";
                break;
              case "dispatched":
                this.statusTranslated = "despachado";
                break;
              case "dis_rejected":
                this.statusTranslated = "entrega rechazada en destino";
                break;
              case "accepted":
                this.statusTranslated = "entregado";

            }
          }
        }


        res = await this.$api.get("/auth/products");
        if (res.status.toString() === "200") {
          this.products = res.data
        }


        res = await this.$api.get("/auth/inventory/locations");
        if (res.status.toString() === "200") {
          this.locations = res.data
        }


        res = await this.$api.get("/auth/users")
        if (res.status.toString() === "200") {
          this.usrs = res.data
        }


        res = await this.$api.get("/auth/inventory/locations/managed/");
        if (res.status.toString() === "200") {
          this.managedLocations = res.data
        }


        res = await this.$api.get(`/auth/transfers/${id}/requests`, {
          params: {
            id: id
          }
        })
        if (res.status.toString() === "200") {
          this.transferRequests = res.data
          if (this.transferRequests === null) {
            this.transferRequests = []
          }
        }


        res = await this.$api.get(`/auth/transfers/${id}/comments`,{
          params: {
            id: id
          }
        })
        if (res.status.toString() === "200") {
          this.comments = res.data
          if (this.comments === null) {
            this.comments = []
          }
        }


        if (this.transfer.status === "requested" && this.managedLocations.includes(this.transfer.locationOrigin) && this.sidebarData.includes("ad-prov-transfer-request")) {
          this.transferRequests.forEach(obj => {
            obj.dispatch = 0;
          })
          res = await this.$api.get(`/auth/inventory/locations/${this.transfer.locationOrigin}`)
          if (res.status.toString() === "200") {
            this.availableInventory = res.data
            if (this.availableInventory === null) {
              this.availableInventory = []
            }

          }

        }



      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'Ha ocurrido un error obteniendo la información',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    async deny(){
      try {
        let data = {
          comment: this.comment
        }
        let res = await this.$api.put(`/auth/transfers/${this.transfer.id}`, data, {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        });
        if (res.status.toString() === "200") {
         this.$swal.fire({
           icon: 'success',
           title: 'Se han guardado los cambios',
           text: '',
           customClass: {
             popup: 'mySwal'
           }
         }).then(result => {
           if (result.isConfirmed) {
             this.$router.push({name:'ShowTransfer', params:{id:this.transfer.id}})
           }
         })
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'No se ha podido registrar los cambios',
          customClass: {
            popup: 'mySwal'
          }
        });
      }
    },
    async dispatch() {

    },
    async accept() {
      try {
        let data = {
          comment: this.comment
        }
        let res = await this.$api.put(`/auth/transfers/${this.transfer.id}`, data, {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        });
        if (res.status.toString() === "200") {
          this.$swal.fire({
            icon: 'success',
            title: 'Se han guardado los cambios',
            text: '',
            customClass: {
              popup: 'mySwal'
            }
          }).then(result => {
            if (result.isConfirmed) {
              this.$router.push({name:'ShowTransfer', params:{id:this.transfer.id}})
            }
          })
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'No se ha podido registrar los cambios',
          customClass: {
            popup: 'mySwal'
          }
        });
      }
    },
    handlePrintOrCancel() {
      if (this.transfer.status === "requested"){
        this.cancel()
      } else {
        this.printPage()
      }
    },
    handleDispatchOrAccept() {
      if (this.transfer.status === "requested"){
        this.dispatch()
      } else {
        this.accept()
      }
    },
    getProductById(id) {
      return this.products.find(product => product.id === id) || {}
    },
    getLocationById(id) {
      return this.locations.find(location => location.id === id) || {}
    },
    getUserById(id) {
      return this.usrs.find(usr => usr.id === id) || {}
    },
    getProductAvailable(id) {
      return this.availableInventory.find(prod => prod.productId === id) || {}
    },
    inputLimiterComments() {
      this.comment = this.comment.replace(/[^a-z0-9 ()/%ñáéíóúü,.~\-"]/gi, '').trimStart()
      if (this.comment.length > this.commentMaxLength) {
        this.comment = this.comment.substring(0, this.commentMaxLength)
      }
    },
  },
  created() {
    this.transferId = this.$route.params.id;
    this.getTransfer(this.transferId)
  },

}

</script>

<template>
  <div id="printMe">
    <h1>Transferencia {{transfer.id}}</h1>
    <label>Estado: {{statusTranslated}}</label>
    <div class="grid-container"
         style="padding-top: 40px; padding-left: 40px; padding-bottom: 40px; background-color: rgba(91, 207, 222, 0.1); margin-bottom: 25px">
      <!-- Column 1 -->
      <div style="text-align: left;">
        <label>Origen:</label>
        <p>{{ getLocationById(transfer.locationOrigin).name }}</p>

        <label>Solicitado por:</label>
        <p>{{ getUserById(transfer.createdBy).firstname }} {{ getUserById(transfer.createdBy).lastname }}</p>

        <label v-if="!(this.transfer.status === 'requested' || this.transfer.status === 'cancelled')">Despachado por:</label>
        <p>{{ getUserById(transfer.dispatchedBy).firstname }} {{ getUserById(transfer.dispatchedBy).lastname }}</p>

        <label v-if="(this.transfer.status === 'accepted' || this.transfer.status === 'dis_rejected') ">Recibido por:</label>
        <p>{{ getUserById(transfer.receivedBy).firstname }} {{ getUserById(transfer.receivedBy).lastname }}</p>

      </div>

      <div style="text-align: left">
        <label>Destino:</label>
        <p>{{ getLocationById(transfer.locationDestiny).name }}</p>

        <label>Solicitado en:</label>
        <p>{{ transfer.createdAt.substring(0, 10) + ' ' + transfer.createdAt.substring(11,19) }}</p>

        <label v-if="!(this.transfer.status === 'requested')">Despachado en:</label>
        <p>{{ transfer.dispatchedAt}}</p>

        <label v-if="(this.transfer.status === 'accepted' || this.transfer.status === 'dis_rejected') ">Recibido en:</label>
        <p>{{ transfer.receivedAt }}</p>


      </div>
    </div>

    <div style="margin-bottom: 25px;" v-if="comments.length">
    <label >Comentarios</label>
    </div>

    <div  v-if="comments.length"
         style="width: 800px; padding: 20px;background-color: rgba(91, 207, 222, 0.1); margin-bottom: 25px; margin-left: auto; margin-right: auto; text-align: left; max-height: 100px; overflow: auto; ">
      <div v-for="comment in comments" :key="comment.id" style="padding-left: 0; ">
        <small style="margin-bottom: 10px" >{{getUserById(comment.userId).firstname}} {{getUserById(comment.userId).lastname}} - {{comment.comment}}</small>
      </div>
    </div>

    <div style="margin-bottom: 25px;">
      <label >Agregar comentario</label>
    </div>

    <div style="position: relative; width: 810px; margin-left: auto; margin-right: auto;">
      <textarea v-model="comment" style="height: 65px; width: 786px;" v-on:input="inputLimiterComments"></textarea>
      <span style="position: absolute; bottom: 5px; right: 10px; font-size: 12px; color: grey;">
            {{ comment.length }}/{{ commentMaxLength}}
          </span>
    </div>

    <label>Resumen productos de solicitud</label>

    <div class="container mt-4 table-container" style="margin-top: 40px">
      <table id="myTable">
        <thead>
        <tr>
          <th>#</th>
          <th>Producto</th>
          <th>Solicitado</th>
          <th v-if="transfer.status === 'requested'">Disponible</th>
          <th v-if="transfer.status === 'requested'">Despachar</th>
        </tr>

        </thead>
        <tbody>
        <tr v-for="(product, index) in transferRequests" :key="index">
          <th scope="row">{{ index + 1 }}</th>
          <td>{{ getProductById(product.product).title }}</td>
          <td>{{ product.quantity }}</td>
          <td v-if="transfer.status === 'requested'">{{ getProductAvailable(product.product).quantity }}</td>
          <td v-if="transfer.status === 'requested'" style="width: 70px;"><input class="tableInput" v-model="product.dispatch"></td>
        </tr>
        </tbody>
      </table>

    </div>

    <label v-if="transfer.status === 'dispatched' || transfer.status === 'accepted' || transfer.status === 'dis_rejected'">Detalle de entrega</label>

    <div class="container mt-4 table-container" style="margin-top: 40px" v-if="transfer.status === 'dispatched' || transfer.status === 'accepted' || transfer.status === 'dis_rejected'">
      <table id="myTable">
        <thead>
        <tr>
          <th>#</th>
          <th>Producto</th>
          <th>Expira</th>
          <th>Codigo</th>
          <th>Lote</th>
          <th>Cantidad</th>
        </tr>

        </thead>
        <tbody>
        <tr v-for="(product, index) in transferRequests" :key="index">
          <th scope="row">{{ index + 1 }}</th>
          <td>{{ getProductById(product.product).title }}</td>
          <td>{{ product.expires.substring(0, 4) === "0000" ? '' : product.expires.substring(0, 10) }}</td>
          <td>{{ product.barCode }}</td>
          <td>{{ product.batch }}</td>
          <td>{{ product.quantity }}</td>
        </tr>
        </tbody>
      </table>

    </div>


  </div>

  <div class="grid-container">
    <div>
      <button @click="handleDispatchOrAccept" v-if="transfer.status === 'requested'"> {{transfer.status === 'requested' ? 'Despachar' : 'Aceptar'}}</button>
    </div>

    <div>
      <button @click="deny" v-if="transfer.status === 'requested'">Rechazar</button>
    </div>
  </div>

  <button @click="handlePrintOrCancel" v-if="transfer.status === 'requested'">{{transfer.status === 'requested' ? 'Cancelar' : 'Imprimir'}}</button>

</template>

<style>


</style>
